<script setup lang="ts">
import AvatarCross from '@/assets/icons/Avatars/AvatarCross.vue';
import type { MessageSchema } from '@/i18n';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import type { ModelRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

const userStore = useUserStore();
const router = useRouter();

const visible: ModelRef<boolean> = defineModel('visible', { type: Boolean, required: true });

function handleConfirm() {
  useUserStore().confirmNoMoreCreditDialog();
  visible.value = false;
}

function goToPurchaseCredits() {
  userStore.confirmNoMoreCreditDialog();
  router.push({ path: '/subscription/credits/purchase' });
  visible.value = false;
}
</script>
<template>
  <Dialog v-model:visible="visible" modal :header="t('credits.noMoreCredit.title')" :style="{ width: '25rem', maxWidth: '90vw' }">
    <AvatarCross class="mx-auto my-4 w-32" />
    <p>{{ t('credits.noMoreCredit.message') }}</p>
    <!-- <div class="flex flex-col gap-4">
    </div> -->
    <template #footer>
      <div class="flex w-full justify-between">
        <Button :label="t('common.ok')" outlined @click="handleConfirm" />
        <Button :label="t('credits.buyMore')" @click="goToPurchaseCredits" />
      </div>
    </template>
  </Dialog>
</template>
